export default __webpack_public_path__ + "static/media/ca.71a0575e.svg";